import React from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

const facilities = [
  {
    id: 1,
    name: 'Millet Parkı Sosyal Tesisi',
    image: '/assets/images/example-post1.webp',
    location: 'Millet Parkı içi, İskenderun'
  },
  {
    id: 2,
    name: '4 Nolu Sosyal Tesis',
    image: '/assets/images/example-post3.webp',
    location: 'İskenderun Merkez'
  },
  {
    id: 3,
    name: 'Denizciler Sosyal Tesis',
    image: '/assets/images/example-post2.webp',
    location: 'Denizciler Mahallesi, İskenderun'
  },
  {
    id: 4,
    name: 'Ziraat Park Aile Kafe',
    image: '/assets/images/example-post.webp',
    location: 'Ziraat Parkı, İskenderun'
  }
];

export default function SocialFacilities() {
  const handleDirections = (location) => {
    const encodedLocation = encodeURIComponent(location);
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodedLocation}`, '_blank');
  };

  return (
    <div className="social-facilities-page">
      <div className="container">
        <div className="row">
          <QuickMenu />
          <div className="col-md-10">
            <h1 className="page-title">Sosyal Tesislerimiz</h1>
            <div className="facilities-grid">
              {facilities.map(facility => (
                <div key={facility.id} className="facility-card">
                  <div className="facility-image">
                    <img src={facility.image} alt={facility.name} />
                  </div>
                  <div className="facility-content">
                  <div className="facility-content-head">
                  <h3>{facility.name}</h3>
                  <p>{facility.location}</p>
                  </div>
                  
                    <button 
                      className="directions-button"
                      onClick={() => handleDirections(facility.location)}
                    >
                      Yol Tarifi Al
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
      
  );
}
